import {
  faHistory,
  faSearch,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { ForeignData_API } from "../../../../APIs/ForeignData.api";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";

export default function ({
  lang,
  refresh,
  setSearch,
  setRefresh,
  setTempValue,
  handleSearch,
  handleChange,
  tempValue,
}) {
  const { proxy } = useSelector((state) => state);
  const [isCollapse, setIsCollapse] = useState(false);
  const [options, setOptions] = useState([]);
  const _token = localStorage.getItem("_token");

  useEffect(() => {
    const fetchData = async () => {
      const res = await ForeignData_API.get(proxy(), _token, {
        table_id: 21692,
      });
      const { data = [] } = res;
      if (data) setOptions(data);
    };

    fetchData();
  }, [_token]);

  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };

  const CustomSelect = ({
    value,
    options,
    onChange,
    label,
    keyField,
    lang,
  }) => {
    return (
      <div className="col-sm-3">
        <label className="col-form-label font-weight-bold">{label}</label>
        <Select
          components={{
            Option: CustomOption,
          }}
          value={
            Array.isArray(value)
              ? value.map((item) => ({
                  label: item,
                  value: item,
                }))
              : []
          }
          options={options.map((item) => ({
            label: item?.[keyField],
            value: item?.[keyField],
          }))}
          noOptionsMessage={() => <>{lang["not found data"]}</>}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          onChange={(opt) => onChange(opt)}
        />
      </div>
    );
  };

  return (
    <>
      <div className="_search col-sm-12">
        <div className="title d-flex justify-content-between align-items-center">
          <h5
            className=""
            style={{
              color: "#44a1a1",
              fontSize: "18px",
              padding: "6px 0px",
            }}
          >
            Tìm kiếm
          </h5>
          <button
            className={`${
              !isCollapse ? "btn btn-secondary" : "btn btn-danger"
            } m-0`}
            onClick={() => setIsCollapse(!isCollapse)}
            style={{
              paddingRight: "12px",
            }}
            type="button"
            data-toggle="collapse"
            data-target="#collapseSearch"
            aria-expanded="false"
            aria-controls="collapseSearch"
          >
            {!isCollapse ? (
              <>
                <FontAwesomeIcon icon={faSearch} /> {lang["search"]}
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faXmark} /> {lang["btn.close"]}
              </>
            )}
          </button>
        </div>
        <div
          className="collapse"
          id="collapseSearch"
          style={{ background: "#dbdbdb" }}
        >
          <div className="collapse-content" style={{ padding: "10px" }}>
            <div className="mb-3 row d-flex align-items-center">
              <label className="col-sm-3 col-form-label _custom-width font-weight-bold">
                Tên Thành Phẩm
              </label>
              <div className="col-sm-3">
                <AsyncPaginate
                  placeholder={lang["select value"]}
                  loadOptions={async (search, loadedOptions, { page }) => {
                    return await loadOptions(
                      page,
                      search,
                      proxy,
                      ["10TSP"],
                      "10TSP"
                    );
                  }}
                  value={
                    Array.isArray(tempValue?.["TenSP"])
                      ? tempValue["TenSP"].map((item) => ({
                          label: item,
                          value: item,
                        }))
                      : []
                  }
                  components={{
                    Option: CustomOption,
                  }}
                  // options={options.map((item) => ({
                  //   label: item?.["10TSP"],
                  //   value: item?.["10TSP"],
                  // }))}
                  noOptionsMessage={() => <>{lang["not found data"]}</>}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(opt) => handleChange("TenSP", opt)}
                  additional={{ page: 0 }}
                  isSearchable={true}
                  allowCreateWhileLoading={false}
                />
              </div>
              <label className="col-sm-3 col-form-label _custom-width font-weight-bold">
                Mã Thành Phẩm
              </label>
              <div className="col-sm-3">
                <AsyncPaginate
                  placeholder={lang["select value"]}
                  loadOptions={async (search, loadedOptions, { page }) => {
                    return await loadOptions(
                      page,
                      search,
                      proxy,
                      ["22MSP"],
                      "22MSP"
                    );
                  }}
                  value={
                    Array.isArray(tempValue?.["MaSP"])
                      ? tempValue["MaSP"].map((item) => ({
                          label: item,
                          value: item,
                        }))
                      : []
                  }
                  components={{
                    Option: CustomOption,
                  }}
                  // options={options.map((item) => ({
                  //   label: item?.["22MSP"],
                  //   value: item?.["22MSP"],
                  // }))}
                  isMulti
                  noOptionsMessage={() => <>{lang["not found data"]}</>}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(opt) => handleChange("MaSP", opt)}
                  additional={{ page: 0 }}
                  isSearchable={true}
                  allowCreateWhileLoading={false}
                />
              </div>
            </div>

            <div className="mb-3 row d-flex align-items-center">
              <div className="col-sm-12 mb-2 font-weight-bold">
                Thống kê ngày
              </div>
              <label className="col-sm-3 col-form-label _custom-width">
                Ngày bắt đầu:
              </label>
              <div className="col-sm-3">
                <input
                  key={refresh}
                  className="form-control"
                  type="date"
                  onChange={(e) => handleChange("from", e.target.value)}
                />
              </div>
              <label className="col-sm-3 col-form-label _custom-width">
                Ngày kết thúc:
              </label>
              <div className="col-sm-3">
                <input
                  key={refresh}
                  className="form-control"
                  type="date"
                  onChange={(e) => handleChange("to", e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3 row d-flex align-items-center">
              <div className="col-sm-12 mb-2 font-weight-bold">
                Thống kê tháng
              </div>
              <label className="col-sm-3 col-form-label _custom-width">
                Tháng bắt đầu:
              </label>
              <div className="col-sm-3">
                <input
                  key={refresh}
                  className="form-control"
                  type="month"
                  onChange={(e) => handleChange("from", e.target.value)}
                />
              </div>
              <label className="col-sm-3 col-form-label _custom-width">
                Tháng kết thúc:
              </label>
              <div className="col-sm-3">
                <input
                  key={refresh}
                  className="form-control"
                  type="month"
                  onChange={(e) => handleChange("to", e.target.value)}
                />
              </div>
            </div>

            <div className="mb-3 row">
              <div className="col-sm-12 mb-2 font-weight-bold">
                Thống kê năm
              </div>
              <label className="col-sm-3 col-form-label _custom-width">
                Năm bắt đầu:
              </label>
              <div className="col-sm-3">
                <Select
                  key={refresh}
                  styles={{
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  options={(() => {
                    const currentYear = new Date().getFullYear();
                    const startYear = currentYear - 30;
                    const options = [];
                    for (let year = currentYear; year >= startYear; year--) {
                      options.push({
                        label: year,
                        value: year,
                      });
                    }
                    return options;
                  })()}
                  placeholder={lang["select year"]}
                  onChange={({ value }) =>
                    handleChange("from", `01-01-${value}`)
                  }
                />
              </div>
              <label className="col-sm-3 col-form-label _custom-width">
                Năm kết thúc:
              </label>
              <div className="col-sm-3">
                <Select
                  key={refresh}
                  styles={{
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                  options={(() => {
                    const currentYear = new Date().getFullYear();
                    const startYear = currentYear - 30;
                    const options = [];
                    for (let year = currentYear; year >= startYear; year--) {
                      options.push({
                        label: year,
                        value: year,
                      });
                    }
                    return options;
                  })()}
                  onChange={({ value }) => handleChange("to", `12-31-${value}`)}
                />
              </div>
            </div>

            <div className="text-right">
              <button
                className="btn btn-secondary mr-3 mb-2"
                type="button"
                onClick={() => {
                  setRefresh((prev) => prev + 1);
                  setSearch("");
                  setTempValue({});
                }}
              >
                <FontAwesomeIcon icon={faHistory} className="mr-1" />
                {lang["Refresh"]}
              </button>
              <button
                className="btn btn-primary mb-2"
                type="button"
                onClick={handleSearch}
              >
                <FontAwesomeIcon icon={faSearch} className="mr-1" />
                {lang["search"]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const loadOptions = async (
  page = 0,
  search = "",
  proxy,
  displayFields,
  isFK
) => {
  return new Promise(async (resolve, reject) => {
    let dataBody = {
      table_id: 21692,
      start_index: page,
      type: "or",
    };

    let newData = {
      options: [],
      hasMore: false,
      additional: {
        page: 0,
      },
    };
    if (search) {
      let criteria = {};
      let criteria_type = {};
      displayFields.forEach((field) => {
        criteria[field] = search;
        criteria_type[field] = "regex";
      });

      dataBody.criteria = criteria;
      dataBody.criteria_type = criteria_type;
    }

    const _token = localStorage.getItem("_token");
    try {
      const { data } = await ForeignData_API.get(proxy(), _token, dataBody);
      let hasMoreValue = true;

      if (!data?.length) {
        hasMoreValue = false;
      }

      if (data.length) {
        const options = data.map((item) => {
          return {
            label: displayFields.map((field) => item[field]).join("|"),
            value: item?.[isFK],
            ...item,
          };
          // }
        });

        newData = {
          options,
          hasMore: hasMoreValue,
          additional: {
            page: hasMoreValue ? page + 15 : page,
          },
        };
      }

      setTimeout(() => {
        resolve(newData);
      }, 100);
    } catch (error) {
      console.error("Error in loadOptions:", error);
      reject(error);
    }
  });
};
